import { render, staticRenderFns } from "./LexonKanbanSidebar.vue?vue&type=template&id=5955a991&scoped=true&lang=pug"
import script from "./LexonKanbanSidebar.vue?vue&type=script&lang=ts"
export * from "./LexonKanbanSidebar.vue?vue&type=script&lang=ts"
import style0 from "./LexonKanbanSidebar.vue?vue&type=style&index=0&id=5955a991&lang=scss&scoped=true"
import style1 from "./LexonKanbanSidebar.vue?vue&type=style&index=1&id=5955a991&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955a991",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5955a991')) {
      api.createRecord('5955a991', component.options)
    } else {
      api.reload('5955a991', component.options)
    }
    module.hot.accept("./LexonKanbanSidebar.vue?vue&type=template&id=5955a991&scoped=true&lang=pug", function () {
      api.rerender('5955a991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonKanban/LexonKanbanSidebar.vue"
export default component.exports